import { fromJS } from "immutable";
import axios from "axios";
import brand from "dan-api/dummy/brand";
import cookie from "react-cookies";
import { getAdminNotificationCount } from "./admin";
var base64 = require("base-64");

// Action Types
const SET_SUPPORT_TICKETS = "SET_SUPPORT_TICKETS";
const SET_SUPPORT_LOADING = "SET_SUPPORT_LOADING";
const SET_SUPPORT_ERROR = "SET_SUPPORT_ERROR";
const SET_TICKET_DETAIL = "SET_TICKET_DETAIL";
const SET_TICKET_FORM_VISIBLE = "SET_TICKET_FORM_VISIBLE";
const CLEAR_SUPPORT_ERROR = "CLEAR_SUPPORT_ERROR";

// Initial State
const initialState = {
  tickets: [],
  ticketDetail: null,
  loading: false,
  error: null,
  ticketFormVisible: false,
};

// Reducer
export default function supportReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case SET_SUPPORT_TICKETS:
      return state.set("tickets", fromJS(action.payload));
    case SET_SUPPORT_LOADING:
      return state.set("loading", action.payload);
    case SET_SUPPORT_ERROR:
      return state.set("error", action.payload);
    case SET_TICKET_DETAIL:
      return state.set("ticketDetail", fromJS(action.payload));
    case SET_TICKET_FORM_VISIBLE:
      return state.set("ticketFormVisible", action.payload);
    case CLEAR_SUPPORT_ERROR:
      return state.set("error", null);
    default:
      return state;
  }
}

// Action Creators
export const setSupportTickets = (tickets) => ({
  type: SET_SUPPORT_TICKETS,
  payload: tickets,
});

export const setSupportLoading = (loading) => ({
  type: SET_SUPPORT_LOADING,
  payload: loading,
});

export const setSupportError = (error) => ({
  type: SET_SUPPORT_ERROR,
  payload: error,
});

export const setTicketDetail = (ticket) => ({
  type: SET_TICKET_DETAIL,
  payload: ticket,
});

export const setTicketFormVisible = (visible) => ({
  type: SET_TICKET_FORM_VISIBLE,
  payload: visible,
});

export const clearSupportError = () => ({
  type: CLEAR_SUPPORT_ERROR,
});

// Thunk Actions
export const getSupportTickets = (brandId) => async (dispatch) => {
  try {
    dispatch(setSupportLoading(true));

    const paketYoldaLogin = cookie.load("PaketYoldaLogin");
    let BrandId;

    if (paketYoldaLogin === "true" || paketYoldaLogin === true) {
      BrandId = cookie.load("PaketYoldaId");
    } else {
      BrandId = cookie.load("BrandId");
    }

    const actualBrandId = BrandId || brandId;

    const response = await axios({
      method: "GET",
      url: brand.urlSocket + `api/SupportTicket/brand/${actualBrandId}`,
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    });

    if (response.data) {
      dispatch(setSupportTickets(response.data));
    }
  } catch (error) {
    dispatch(setSupportError(error.response?.data?.message || error.message));
  } finally {
    dispatch(setSupportLoading(false));
  }
};

export const getTicketDetail = (ticketId) => async (dispatch) => {
  try {
    dispatch(setSupportLoading(true));
    const response = await axios({
      method: "GET",
      url: brand.urlSocket + `api/SupportTicket/${ticketId}`,
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    });

    if (response.data) {
      dispatch(setTicketDetail(response.data));
    }
  } catch (error) {
    dispatch(setSupportError(error.response?.data?.message || error.message));
  } finally {
    dispatch(setSupportLoading(false));
  }
};

export const createSupportTicket = (ticketData) => async (dispatch) => {
  try {
    dispatch(setSupportLoading(true));

    const paketYoldaLogin = cookie.load("PaketYoldaLogin");
    const restaurantName = cookie.load("RestaurantName");
    let BrandId = cookie.load("BrandId");

    let UserId;
    let brandName;
    let platform;
    let customerName;

    if (paketYoldaLogin === "true" || paketYoldaLogin === true) {
      UserId = cookie.load("PaketYoldaId");
      brandName = cookie.load("JaviKuryeBrandName") || "";
      platform = "javikurye";
      BrandId = cookie.load("PaketYoldaId");
      customerName = cookie.load("PaketYoldaUsername");
    } else if (restaurantName) {
      // JavaPos platformundan gelmiş
      UserId = cookie.load("UserId");
      BrandId = cookie.load("BrandId");
      brandName = restaurantName;
      platform = "javipos";
      customerName = cookie.load("JaviKuryeBrandName") || "";
    } else {
      // Varsayılan değerler
      UserId = cookie.load("UserId");
      BrandId = cookie.load("BrandId");
      brandName = ticketData.BrandName || "";
      platform = ticketData.Platform || "javipos";
      customerName = ticketData.CustomerName || "";
    }

    const response = await axios({
      method: "POST",
      url: brand.urlSocket + "api/SupportTicket",
      data: {
        ...ticketData,
        CustomerId: UserId,
        CreatedBy: UserId,
        BrandId: BrandId,
        BrandName: brandName,
        Platform: platform,
        CustomerName: customerName,
      },
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
        "Content-Type": "application/json",
      },
    });

    if (response.data) {
      dispatch(getSupportTickets(UserId));
      dispatch(setTicketFormVisible(false));

      dispatch(getAdminNotificationCount());
      if (platform === "javikurye") {
        // dispatch(getPaketYoldaSupportNotificationCount());
      }

      return response.data;
    }
  } catch (error) {
    dispatch(setSupportError(error.response?.data?.message || error.message));
    throw error;
  } finally {
    dispatch(setSupportLoading(false));
  }
};

export const addTicketResponse = (ticketId, responseData) => async (
  dispatch
) => {
  try {
    dispatch(setSupportLoading(true));

    const paketYoldaLogin = cookie.load("PaketYoldaLogin");
    let UserId;

    if (paketYoldaLogin === "true" || paketYoldaLogin === true) {
      UserId = cookie.load("PaketYoldaId");
    } else {
      UserId = cookie.load("UserId");
    }

    const response = await axios({
      method: "POST",
      url: brand.urlSocket + `api/SupportTicket/${ticketId}/response`,
      data: {
        ...responseData,
        ResponderId: UserId || responseData.ResponderId,
      },
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
        "Content-Type": "application/json",
      },
    });

    if (response.data) {
      dispatch(getTicketDetail(ticketId));
      return response.data;
    }
  } catch (error) {
    dispatch(setSupportError(error.response?.data?.message || error.message));
    throw error;
  } finally {
    dispatch(setSupportLoading(false));
  }
};

export const updateTicketStatus = (ticketId, statusData) => async (
  dispatch
) => {
  try {
    dispatch(setSupportLoading(true));
    const response = await axios({
      method: "PUT",
      url: brand.urlSocket + `api/SupportTicket/${ticketId}/status`,
      data: statusData,
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
        "Content-Type": "application/json",
      },
    });

    if (response.data) {
      dispatch(getTicketDetail(ticketId));
      return response.data;
    }
  } catch (error) {
    dispatch(setSupportError(error.response?.data?.message || error.message));
    throw error;
  } finally {
    dispatch(setSupportLoading(false));
  }
};

export const deleteTicket = (ticketId) => async (dispatch) => {
  try {
    dispatch(setSupportLoading(true));

    const paketYoldaLogin = cookie.load("PaketYoldaLogin");
    let UserId;

    if (paketYoldaLogin === "true" || paketYoldaLogin === true) {
      UserId = cookie.load("PaketYoldaId");
    } else {
      UserId = cookie.load("UserId");
    }

    await axios({
      method: "DELETE",
      url: brand.urlSocket + `api/SupportTicket/${ticketId}`,
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    });

    dispatch(getSupportTickets(UserId));
  } catch (error) {
    dispatch(setSupportError(error.response?.data?.message || error.message));
    throw error;
  } finally {
    dispatch(setSupportLoading(false));
  }
};

export const markTicketAsReadCustomer = (ticketId) => async (dispatch) => {
  try {
    await axios({
      method: "PUT",
      url: brand.urlSocket + `api/SupportTicket/${ticketId}/mark-read-customer`,
      headers: {
        Authorization:
          "Basic " + base64.encode("JarvisPos" + ":" + "Shark123*"),
      },
    });

    const paketYoldaLogin = cookie.load("PaketYoldaLogin");
    if (paketYoldaLogin === "true" || paketYoldaLogin === true) {
      // JavaKurye platformu
      // dispatch(getPaketYoldaSupportNotificationCount());
    }
  } catch (error) {
    console.error("Error marking ticket as read:", error);
  }
};
